import { Component, Inject, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Producto } from "@p-parametria/mantenimiento/abc-empresas/interfaces/producto";
import { OpcionesRequest } from "@shared/interfaces/request/opciones";
import { CampoTablaWhereService } from "@shared/services/campo-tabla-where.service";
import { EmpresasService } from "@p-parametria/mantenimiento/abc-empresas/services/empresas.service";
import { OpcionesService } from "@p-p-portafolio/services/opciones.service";
import { ProductosService } from "@pages/tipos-credito/services/productos.service";
import { InjectableService } from "@shared/utils/injectable.service";
import { SwalService } from "@shared/utils/swal.service";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ISetEmpresaReq } from "@p-parametria/mantenimiento/abc-empresas/interfaces/IABCEmpresas";
import {
    IGetCampoNuevoReq,
    IGetCampoNuevoRes,
    IGetCamposReq,
    IGetCamposRes,
    IGetTablasCampoReq,
    IGetTablasCampoRes,
} from "@p-parametria/mantenimiento/abc-empresas/interfaces/ICustomizables";
import { AutoCompleteCompleteEvent } from "primeng/autocomplete";
import moment = require("moment");
import { HelpersService } from "@shared/helpers/helpers.service";
import { IGetCuentasReq, IGetCuentasRes } from "../../interfaces/ICuentas";
import Swal from "sweetalert2";
import { AbcEmpresasCustomizablesComponent } from "../abc-empresas-customizables/abc-empresas-customizables.component";

@Component({
    selector: "app-abc-empresas-cuentas",
    templateUrl: "./abc-empresas-cuentas.component.html",
    styleUrls: ["./abc-empresas-cuentas.component.css"],
})
export class AbcEmpresasCuentasComponent implements OnInit {
    dataSource: any;
    newModal: boolean = false;
    isEdit: boolean = false;

    formDataCuentas = this._fb.group({
        sCuenta: ["", Validators.required],
        sDescripcion: [""],
        sClaveContabilidadDeb: [""],
        sClaveContabilidadCre: [""],
    });

    constructor(
        private _fb: UntypedFormBuilder,
        private _dialogRef: MatDialogRef<AbcEmpresasCuentasComponent>,
        private _helpers: HelpersService,
        private empresasService: EmpresasService,
        private _swalService: SwalService,
        public _dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public model: any
    ) {}

    ngOnInit(): void {
        this.getCuentas();
    }

    limpiarFormulario() {
        this.formDataCuentas.reset();
        this.formDataCuentas.controls["sCuenta"].enable();
        this.isEdit = false;
    }

    abrirModal() {
        this.limpiarFormulario();
        this.newModal = true;
    }

    cerrarModal() {
        this.limpiarFormulario();
        this.newModal = false;
    }

    getCuentas() {
        const payload: IGetCuentasReq = {
            sUsuario: JSON.parse(sessionStorage.getItem("user")),
            sEmpresa: this.model.sEmpresa,
            sCuenta: "",
            sDescripcion: "",
            sClaveContabilidadDeb: "",
            sClaveContabilidadCre: "",
        };
        this.empresasService.GetCuentas(payload).subscribe((res: IGetCuentasRes) => {
            this.dataSource = res.data;
        });
    }

    addCuenta() {
        const payload: IGetCuentasReq = {
            sUsuario: JSON.parse(sessionStorage.getItem("user")),
            sEmpresa: this.model.sEmpresa,
            sCuenta: this.formDataCuentas.value.sCuenta,
            sDescripcion: this.formDataCuentas.value.sDescripcion,
            sClaveContabilidadDeb: this.formDataCuentas.value.sClaveContabilidadDeb,
            sClaveContabilidadCre: this.formDataCuentas.value.sClaveContabilidadCre,
        };
        this.empresasService.CreateCuenta(payload).subscribe((res: IGetCuentasRes) => {
            if (res.success) {
                this.cerrarModal();
                this.getCuentas();
                this._swalService.success("Cuenta creada con éxito");
                return;
            }
        });
    }

    updateCuenta() {
        const payload: IGetCuentasReq = {
            sUsuario: JSON.parse(sessionStorage.getItem("user")),
            sEmpresa: this.model.sEmpresa,
            sCuenta: this.formDataCuentas.getRawValue().sCuenta,
            sDescripcion: this.formDataCuentas.value.sDescripcion,
            sClaveContabilidadDeb: this.formDataCuentas.value.sClaveContabilidadDeb,
            sClaveContabilidadCre: this.formDataCuentas.value.sClaveContabilidadCre,
        };
        this.empresasService.EditCuenta(payload).subscribe((res: IGetCuentasRes) => {
            if (res.success) {
                this.cerrarModal();
                this.getCuentas();
                this._swalService.success("Cuenta actualizada con éxito");
                return;
            }
        });
    }

    editCuenta(model: any) {
        this.isEdit = true;
        this.newModal = true;
        this.formDataCuentas.patchValue(model);
        this.formDataCuentas.controls["sCuenta"].disable();
    }

    deleteCuenta(model: any) {
        Swal.fire({
            title: "Eliminar Cuenta",
            text: "¿Está seguro de eliminar la cuenta?",
            icon: "warning",
            showCancelButton: true,
            iconColor: "#d33",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, Eliminar",
            cancelButtonText: "No, Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                const payload: IGetCuentasReq = {
                    sUsuario: JSON.parse(sessionStorage.getItem("user")),
                    sEmpresa: this.model.sEmpresa,
                    sCuenta: model.sCuenta,
                    sDescripcion: model.sDescripcion,
                    sClaveContabilidadDeb: model.sClaveContabilidadDeb,
                    sClaveContabilidadCre: model.sClaveContabilidadCre,
                };
                this.empresasService.DeleteCuenta(payload).subscribe((res: IGetCuentasRes) => {
                    if (res.success) {
                        this.getCuentas();
                        this._swalService.success("Cuenta eliminada con éxito");
                        return;
                    }
                });
            }
        }).catch((error) => {
            console.error(error);
        });
    }
    openCustomizables(): void {
        this._dialog.open(AbcEmpresasCustomizablesComponent, {
          width: '1000px',
          height: '1000px',
          disableClose: true,
          panelClass: ['custom-dialog-zindex'],
          hasBackdrop: true,
          autoFocus: false,
          data: {
            sTabla: 'CaTBL_CatalogoCuentas',
            sClave: `${this.model.sEmpresa}-${this.formDataCuentas.get('sCuenta')?.value}`,
            sNombre: this.formDataCuentas.get('sDescripcion')?.value,
            sTipo: 'Cuenta'
          }
        });
      }

    close() {
        this._dialogRef.close();
    }
}
